import { LocalDate } from './local-date.model';

export interface InfoFieldRow {
  label: string;
  text?: string;
  localDate?: LocalDate;
}
